export default __webpack_public_path__ + "static/media/withdrawal-dark.17dd9950.svg";